import React from 'react';
import { CheckIcon, XIcon } from './Icons';
import './ChecklistItem.css';

interface ChecklistItemProps {
  done: boolean;
  details: JSX.Element;
}

const ChecklistItem: React.FC<ChecklistItemProps> = ({ done, details }) => {
  return (
    <tr className='text-lg'>
      <td className='children-inline'>
        {done ? (
          <>
            <CheckIcon />
            <p className='ml-4'>Done</p>
          </>
        ) : (
          <>
            <XIcon />
            <p className='ml-4'>Awaiting</p>
          </>
        )}
      </td>
      <td>{details}</td>
    </tr>
  );
};

export default ChecklistItem;
